module.exports = __webpack_public_path__ + "static/img/200245.1c333c3f.png";